import { create } from 'zustand';

/**
 * What the site tells the embedded messenger, and what the messenger asks of the site.
 *
 * Used to be window.postMessage between the site and the Hami iframe; now that the messenger
 * lives in the same page it is a plain store. The assistant drawer (site) writes `vardast`,
 * the chat header (messenger) reads it and calls `open`.
 */
interface HamiHostState {
  vardast: { available: boolean; label: string; open: (() => void) | null };
  setVardast: (vardast: HamiHostState['vardast']) => void;
}

export const useHamiHostStore = create<HamiHostState>(set => ({
  vardast: { available: false, label: '', open: null },
  setVardast: vardast => set({ vardast }),
}));
